import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { SelectedPackage } from "types/promoType";
import { Colors } from "utils/colors";
import { FaRegTrashAlt } from "react-icons/fa";

interface IProps {
  pkg: SelectedPackage;
  removeCartItem: (pkg: SelectedPackage) => void;
}

const CartItem = ({ pkg, removeCartItem }: IProps) => {
  return (
    <Container>
      <Top>
        <IconContainer></IconContainer>
        <div>
          <Typography size="lg" weight="medium" mb="0.4">
            {pkg.stationName}
          </Typography>
          <Typography color={Colors.grey500}>{pkg.packageName}</Typography>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <Typography>{pkg.stationType}</Typography>
        </div>
      </Top>
      <Bottom>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.4rem",
            cursor: "pointer"
          }}
          onClick={() => removeCartItem(pkg)}
        >
          <FaRegTrashAlt color={Colors.danger} />
          <Typography color={Colors.danger} size="s">
            Remove
          </Typography>
        </div>
        <Typography size="xl" weight="medium">
          {pkg.packagePrice}$
        </Typography>
      </Bottom>
    </Container>
  );
};

export default CartItem;

const Container = styled.div`
  width: 100%;
`;

const Top = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const IconContainer = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: 10px;
  margin-right: 1.6rem;
  background-color: black;
`;

const Bottom = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.8rem;
`;
